import { OrderFrequencyType } from "../types/scheduled-order";

export interface IBundle {
  id: number;
  siteId: number;
  name: string;
  type: BundleType;
  minItemCount?: number;
  maxItemCount?: number;
  dynamicBundleDiscountCriteria?: DynamicBundleDiscountCriteria;
  discountType?: BundleDiscountType;
  isActive: boolean;

  inactivatedAt?: Date;
  products: IBundleProduct[];
  rewardsSettings: IBundleItemRewardSetting[];
  frequencyOptions?: BundleShippingFrequencyOptionsDto[];
}
export enum BundleDiscountType {
  Unknown = 0,
  PercentageAndFreeShipping = 3,
}
export interface IBundleItemRewardSetting {
  id: number;
  bundleId: number;
  itemCountToActivateReward: number;
  rewardDiscountPercentage?: number;
  rewardFixedShippingCost?: number;
  discountType?: string;
  isActive: boolean;

  inactivatedAt?: Date;
}
export interface IBundleProduct {
  id?: number;
  bundleId: number;
  productId: number;
  externalProductId: string;
  isActive: boolean;

  inactivatedAt?: Date;
}
export enum BundleType {
  Unknown = 0,
  Dynamic = 1,
  Fixed = 2,
}
export enum DynamicBundleDiscountCriteria {
  Unknown = 0,
  TotalNumberOfItems = 1,
}

export interface ISiteBundlesPutDto {
  siteId: number;
  name: string;
  type: BundleType;
  minItemCount?: number;
  maxItemCount?: number;
  dynamicBundleDiscountCriteria?: DynamicBundleDiscountCriteria;
  discountType?: BundleDiscountType;
  products?: BundleProductPutDto[];
  rewardsSettings?: BundleItemRewardPutDto[];
  isActive?: boolean;
}

export interface BundleProductPutDto {
  id?: number;
  bundleId: number;
  productId: number;
  externalProductId: string;
}

export interface BundleItemRewardPutDto {
  id?: number;
  bundleId: number;
  itemCountToActivateReward: number;
  rewardDiscountPercentage?: number;
  rewardFixedShippingCost?: number;
}

export interface IBundleByIdDto {
  id: number;
  siteId: number;
  name: string;
  type: BundleType;
  minItemCount?: number;
  maxItemCount?: number;
  dynamicBundleDiscountCriteria?: DynamicBundleDiscountCriteria;
  discountType?: BundleDiscountType;
  isActive: boolean;

  products: IBundleProductGetDto[];
  rewardsSettings: IBundleItemRewardSettingGetDto[];
}
export interface IBundleProductGetDto {
  id: number;
  bundleId: number;
  productId: number;
  externalProductId: string;
}
export interface IBundleItemRewardSettingGetDto {
  id: number;
  bundleId: number;
  itemCountToActivateReward: number;
  rewardDiscountPercentage?: number;
  rewardFixedShippingCost?: number;
}
export interface ISiteBundlesGetDto {
  id: number;
  siteId: number;
  name: string;
  type: BundleType;
  minItemCount?: number;
  maxItemCount?: number;
  dynamicBundleDiscountCriteria?: DynamicBundleDiscountCriteria;
  discountType?: BundleDiscountType;
  isActive: boolean;

  products?: IBundleProductGetDto[] | null;
  rewardsSettings?: IBundleItemRewardSettingGetDto[] | null;
}

export interface GetBundleSettingsAggregatedDto {
  bundleId: number;
  bundleName: string;
  products: BundleProductDto[];
  rewardsSettings: BundleItemRewardSettingGetDto[];
  frequencyOptions: BundleShippingFrequencyOptionsDto[];
}

export interface BundleShippingFrequencyOptionsDto {
  id?: number;
  bundleId: number;
  frequency: number;
  type: OrderFrequencyType;
  discountPercentage?: number;
}

export interface BundleProductDto {
  productId: number;
  externalProductId: string;
  productTitle: string;
  price: number;
  salePrice?: number;
  availability: Availability;
  imageThumbUrl: string;
  stock?: number;
  quantity?: number;
}

export interface BundleItemRewardSettingGetDto {
  id: number;
  bundleId: number;
  itemCountToActivateReward: number;
  rewardDiscountPercentage?: number;
  rewardFixedShippingCost?: number;
}

export enum Availability {
  InStock = 0,
  OutOfStock = 1,
  PreOrder = 2,
}

export interface CalculateBundleRewardsRequest {
  productIds: number[];
}
